<div
  #ndfEntryDefault
  fxFlex
  fxLayout="column"
  fxLayoutAlign="center"
  fxLayoutGap="5px"
  class="order-entry-settings__gamma__body"
>
  <!-- CLIENT -->
  <div fxFlex="1 1 100%" class="order-entry-settings__ndf__row">
    <ic-autocomplete-defaults
      #inputClient
      id="defaults_client"
      inputId="defaults_client"
      class="order-entry__panel-client-details__data-client"
      mode="client"
      [disabled]="data.client.disabled"
      [allowEmpty]="true"
      [constraint]="data.client.accountConstraint"
      [constraintAutoSelect]="control.clientAccountConstraintAutoSelect"
      [(ngModel)]="data.client.value"
      (blur)="onClientChange($event)"
      (onTabChange)="onClientTabChange($event)"
      (onClientSelect)="onClientSelect($event)"
    >
    </ic-autocomplete-defaults>
    <!--  (ngModelChange)="onClientChange($event)" -->
  </div>
  <!-- ACCOUNT -->
  <div fxFlex="1 1 100%" class="order-entry-settings__ndf__row">
    <ic-autocomplete-defaults
      #inputAccount
      id="defaults_account"
      inputId="defaults_account"
      class="order-entry__panel-client-details__data-account"
      mode="account"
      [disabled]="data.account.disabled"
      [allowEmpty]="true"
      [constraint]="data.client.value"
      [constraintAutoSelect]="control.clientAccountConstraintAutoSelect"
      [(ngModel)]="data.account.value"
      (blur)="onAccountChange($event)"
      (onTabChange)="onAccountTabChange($event)"
    >
    </ic-autocomplete-defaults>
    <!-- (ngModelChange)="onAccountChange($event)" -->
  </div>
  <!-- CCY PAIR / ORDER TYPE -->
  <div
    fxFlex="1 1 100%"
    class="order-entry-settings__ndf__row"
    fxLayout="row"
    fxLayoutGap="20px"
    fxLayoutAlign="start"
  >
    <ic-ccy-pair-defaults
      fxFlex="1 1 50%"
      #inputCcyPair
      id="oe-defaults_ndf_ccy-pair"
      inputId="currencyPair"
      class="bfx-component-wrapper"
      [label]="data.currencyPair.label"
      [dataset]="data.currencyPair.dataset"
      [marketRateDisable]="true"
      [(ngModel)]="data.currencyPair.product"
      [allowEmpty]="true"
      (ngModelChange)="onCurrencyPairChange($event)"
    >
    </ic-ccy-pair-defaults>
    <ic-autocomplete-defaults
      fxFlex="1 1 50%"
      #inputOrderType
      id="defaults_order-type"
      inputId="defaults_order-type"
      mode="type"
      [allowEmpty]="true"
      [label]="data.orderType.label"
      [disabled]="data.orderType.disabled"
      [dataset]="data.orderType.dataset"
      [(ngModel)]="data.orderType.value"
      (ngModelChange)="onOrderTypeChange($event)"
      class="bfx-component-wrapper"
    >
    </ic-autocomplete-defaults>
  </div>

  <!-- CCY PAIR / TYPE -->
  <div
    fxFlex="1 1 100%"
    class="order-entry-settings__ndf__row"
    fxLayout="row"
    fxLayoutGap="20px"
    fxLayoutAlign="start"
    [style.display]="control.showIntentAndAmount ? 'inherit' : 'none'"
  >
    <div
      fxFlex="1 1 50%"
      fxLayout="row"
      fxLayoutGap="4px"
      [style.padding-top]="0"
      class="bfx-component-wrapper"
    >
      <ic-fixed-ccy
        fxFlex="1 1 50%"
        #toggleFixedCcy
        id="defaults_fixed-ccy"
        inputId="defaults_fixed-ccy"
        class="order-entry__panel-financials__fixed-ccy"
        label="Dealt Currency"
        [ccyPair]="data.fixedCcy.ccyPair"
        [(ngModel)]="data.fixedCcy.value"
        (ngModelChange)="onFixedCcyToggleChange($event)"
      >
      </ic-fixed-ccy>
    </div>
    <bfx-amount-spinner
      fxFlex="1 1 50%"
      #inputOrderAmount
      id="defaults_order-amount"
      inputId="defaults_order-amount"
      class="order-entry__panel-financials__order-amount"
      [label]="data.orderAmount.label"
      [mandatory]="false"
      [keyupAssignZero]="false"
      [minMaxTouchValid]="false"
      [currency]="data.fixedCcy.fixedCcy"
      [(ngModel)]="data.orderAmount.value"
      (ngModelChange)="onOrderAmountChange($event)"
      (blur)="onOrderAmountBlur($event)"
      [size]="'sm'"
    >
    </bfx-amount-spinner>
  </div>

  <!-- GAMMA DETAILS -->
  <div
    fxFlex="1 1 100%"
    class="order-entry-settings__ndf__row"
    fxLayout="row"
    fxLayoutGap="20px"
    fxLayoutAlign="start"
  >
    <number-spinner
      fxFlex="1 1 50%"
      id="oe-control_delta"
      inputId="delta"
      #inputDelta
      class="order-entry__panel-financials__delta"
      [label]="data.delta.label"
      [disabled]="data.delta.disabled"
      [locked]="data.delta.disabled"
      [(ngModel)]="data.delta.value"
      (ngModelChange)="onDeltaChanged($event)"
      [step]="data.delta.step"
      modelValueType="NUMBER"
      [minPrecision]="data.delta.precision"
      [maxPrecision]="data.delta.precision"
      [min]="data.delta.minValue"
      [max]="99999"
      [externalState]="data.delta.externalState"
      [size]="'sm'"
    >
    </number-spinner>
    <div fxFlex="1 1 50%"></div>
  </div>

  <div
    fxFlex="1 1 100%"
    class="order-entry-settings__ndf__row"
    fxLayout="row"
    fxLayoutGap="20px"
    fxLayoutAlign="start"
  >
    <number-spinner
      fxFlex="1 1 50%"
      id="oe-control_rungsAbove"
      inputId="rungsAbove"
      #inputRungsAbove
      class="order-entry__panel-financials__rungsAbove"
      [min]="0"
      [max]="data.rungsAbove.max"
      [maxPrecision]="0"
      step="1"
      modelValueType="NUMBER"
      [disabled]="data.rungsAbove.disabled"
      [locked]="data.rungsAbove.disabled"
      [label]="data.rungsAbove.label"
      [(ngModel)]="data.rungsAbove.value"
      (ngModelChange)="onRungsAboveChanged($event)"
      [externalState]="data.rungsAbove.externalState"
      [size]="'sm'"
    >
    </number-spinner>
    <number-spinner
      fxFlex="1 1 50%"
      id="oe-control_rungsBelow"
      inputId="rungsBelow"
      #inputRungsBelow
      class="order-entry__panel-financials__rungsBelow"
      [min]="0"
      [max]="data.rungsBelow.max"
      [maxPrecision]="0"
      [step]="1"
      modelValueType="NUMBER"
      [disabled]="data.rungsBelow.disabled"
      [locked]="data.rungsBelow.disabled"
      [label]="data.rungsBelow.label"
      [(ngModel)]="data.rungsBelow.value"
      (ngModelChange)="onRungsBelowChanged($event)"
      [externalState]="data.rungsBelow.externalState"
      [size]="'sm'"
    >
    </number-spinner>
  </div>

  <!-- GOOD FROM/UNTIL  -->
  <div
    fxFlex="1 1 100%"
    class="order-entry-settings__ndf__row"
    fxLayout="row"
    fxLayoutGap="20px"
    fxLayoutAlign="start"
  >
    <!-- GOOD FROM -->
    <div fxFlex="1 1 calc(50%- 20px)" class="input-good-date">
      <bfx-autoComplete
        #inputGoodFrom
        id="defaults_good-from"
        inputId="defaults_good-from"
        class="interface-control__custom-input-autocomplete__container"
        [(ngModel)]="data.goodFrom.value"
        [label]="data.goodFrom.label"
        [suggestions]="data.goodFrom.suggestions"
        [settingsCorrection]="true"
        [dropdown]="true"
        [skipSorting]="true"
        [autoHighlight]="true"
        [allowEmptySelection]="true"
        [emptyIsInactive]="true"
        delay="4"
        field="label"
        dataKey="value"
        (ngModelChange)="onGoodFromChange($event)"
        (completeMethod)="goodFromSuggestion($event)"
        [size]="'sm'"
        appendTo="body"
      >
      </bfx-autoComplete>
    </div>
    <!-- GOOD UNTIL -->
    <div fxFlex="1 1 calc(50%- 20px)" class="input-good-date">
      <bfx-autoComplete
        #inputGoodFrom
        id="defaults_good-until"
        inputId="defaults_good-until"
        class="interface-control__custom-input-autocomplete__container"
        [(ngModel)]="data.goodUntil.value"
        [label]="data.goodUntil.label"
        [suggestions]="data.goodUntil.suggestions"
        [settingsCorrection]="true"
        [dropdown]="true"
        [skipSorting]="true"
        [autoHighlight]="true"
        [allowEmptySelection]="true"
        [emptyIsInactive]="true"
        delay="4"
        field="label"
        dataKey="value"
        (ngModelChange)="onGoodUntilChange($event)"
        (completeMethod)="goodUntilSuggestion($event)"
        [size]="'sm'"
        appendTo="body"
      >
      </bfx-autoComplete>
    </div>
  </div>

  <div
    fxFlex="1 1 100%"
    class="order-entry-settings__ndf__row"
    [style.visibility]="data.privateOrder.show  ? 'visible': 'hidden'"
    fxLayout="row"
    fxLayoutGap="20px"
    fxLayoutAlign="start"
  >
    <ic-private-order-defaults
      fxFlex="1 1 50%"
      #inputPrivateOrder
      id="defaults_private-order"
      inputId="defaults_private-order"
      [loading]="control.isLoading"
      [label]="data.privateOrder.label"
      [(ngModel)]="data.privateOrder.value"
      (ngModelChange)="onPrivateOrderChange()"
    >
    </ic-private-order-defaults>
    <div fxFlex="1 1 50%"></div>
  </div>
</div>
